module.exports = __webpack_public_path__ + "static/img/incheon-ag-final-report.000a4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/incheon-ag-final-report.jpg
// module id = m27g
// module chunks = 0